import { render, staticRenderFns } from "./EditScoreGrade.vue?vue&type=template&id=21474081&"
import script from "./EditScoreGrade.vue?vue&type=script&lang=ts&"
export * from "./EditScoreGrade.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports